import { connect } from 'react-redux'

import { RootState } from '../../../store'
import ManageAgencyDetail from '../../../components/pages/ManageAgency/ManageAgencyDetail'

/**
 * Import
 * - Actions
 */
import {
    fetchAgencySummary,
    fecthTrackerActivityTypes,
    getUserDetail,
    fetchUsers,
    deactivateUser,
    fecthPoliciesList,
    fecthRenewalsList,
    fecthLapseRenewal,
    fecthRenewAsIs,
} from '../../../actions'

const mapStateToProps = (state: RootState) => {
    return {
        agencySummary: state.agencySummary,
        activityTracker: state.activityTracker,
        userDetail: state.users.userInformation,
        sessionUser: state.userDetail,
        usersList: state.users.users,
        deactivateUser: state.users.deactivateUser,
        clientList: state.clientList,
        renewals: state.renewals.renewals,
        renewAsIs: state.renewals.renewAsIs,
    }
}

export default connect(mapStateToProps, {
    fetchAgencySummary: fetchAgencySummary,
    fecthTrackerActivityTypes: fecthTrackerActivityTypes,
    getUserDetail: getUserDetail,
    fecthPoliciesList: fecthPoliciesList,
    fetchUsers: fetchUsers,
    fetchDeactivateUser: deactivateUser,
    fecthRenewalsList,
    fecthLapseRenewal,
    fecthRenewAsIs,
})(ManageAgencyDetail)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/ManageAgency/ManageAgencyDetail.tsx